const config = {
    // 系统展示模块 true为展示，false为不展示
    getSystem: { CAMDS: true, IMDS: true, LOCAL: true },
    firstSystem:['camds','imds'],//页签的第一个系统为什么系统
    paramsExport:true,//参数报告导出<当前只有长城需要开启>
    TwoRateDerived_EU:false,//两率报告导出(欧盟)<当前只要吉利需要打开>
    TwoRateDerived_Custom:false,//两率报告导出(自定义)<当前只要吉利需要打开>
    CheckingConfiguration:true,//配置审核批准按钮是否校验表单分析<当前只长城需要打开此配置,现阶段其他企业不用>
    loginPage:true,//false 为开启验证码 true为关闭验证码<当前只有吉利需要开启>
    ExemptionOptionConfiguration:false,//在审核规则配置页面是否开启豁免选项的配置<当前只有泛亚需要开启>
    ModelFile:false,//在文件管理页面是否开启车型文件上传的配置<当前只有泛亚需要开启>
    Fratify:false,//本地数据管理审核弹框的强制通过按钮的配置<当前只有泛亚需要开启>
    CitationAnalysis:false,//本地数据管理引用分析按钮开关<当前只有泛亚需要开启>
    EPTableHeaderList:false,//EP<当前只有泛亚需要开启>
    bomExportCSV:true,//imds转换为camds导出CSV<>
    CQCBtn:true//CQC按钮控制
}
export default config
